import React, { useEffect, useState } from 'react';
import { Card, Avatar, Typography, Stack, Button, Grid, Box, Checkbox, CircularProgress, Tooltip, Input, Modal, ModalClose, ModalDialog, DialogTitle, DialogContent, Textarea, Drawer, FormControl, Select, Option, Link, Chip, Slider, RadioGroup, Radio, FormHelperText, LinearProgress } from '@mui/joy';
import { RiDeleteBin5Line, RiMessage2Fill, RiPencilFill } from "react-icons/ri";
import axios from 'axios';
import { Explore as ExploreIcon, Add, ArrowLeft, ArrowRight, Star, Cake, Celebration, Check, Delete, Favorite, HourglassBottom, Info, PlusOne, Verified } from '@mui/icons-material';
import IconButton from '@mui/joy/IconButton';
import { useAuth } from '../context/AuthContext';
import { Transition } from 'react-transition-group';
import { useTheme, useMediaQuery } from '@mui/material';
import { MdDelete } from "react-icons/md";
import CardIcon from '../img/card.png';
import MoneyIcon from '../img/money.png';
import { useLanguage } from '../LanguageProvider';
import DragAndDrop from '../components/DragAndDrop';
import TimeAgo from '../components/TimeAgo';
import InputPairs from '../components/InputPairs';

import Accordion from '@mui/joy/Accordion';
import AccordionDetails from '@mui/joy/AccordionDetails';
import AccordionGroup from '@mui/joy/AccordionGroup';
import AccordionSummary from '@mui/joy/AccordionSummary';
import { useLocation, useNavigate } from 'react-router-dom';
import { Rating } from 'react-simple-star-rating'

import PixelCard from '../blocks/Components/PixelCard/PixelCard'
import Waves from '../blocks/Backgrounds/Waves/Waves'
import zIndex from '@mui/material/styles/zIndex';
import { getApiUrl } from '../utils/api';

const categories = [
    { key: "Trending", value: null },
    { key: "Programming", value: "Programming" },
    { key: "Writing", value: "Writing" },
    { key: "Productivity", value: "Productivity" },
    { key: "Research_Analysis", value: "Research & Analysis" },
    { key: "Education", value: "Education" },
    { key: "Lifestyle", value: "Lifestyle" },
    { key: "Business", value: "Business" },
    { key: "Entertainment", value: "Entertainment" }
];

function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const LikeButton = ({ model, user, onClickEvent, theme }) => {
    const [rating, setRating] = useState(model.calculated_rating);
    const [isRated, setIsRated] = useState(model.userRating != null);

    useEffect(() => {
        setRating(model.calculated_rating);
    }, [model.calculated_rating]);

    useEffect(() => {
        setIsRated(model.userRating);
    }, [model.userRating]);

    return (
        <Button
            onClick={() => onClickEvent()}
            startDecorator={<Star sx={{ height: 16, width: 16, mr: -0.5 }} />}
            variant="soft"
            disabled={model.is_moderated != "TRUE"}
            color="warning"
            sx={{ marginLeft: '8px', borderRadius: 250, backgroundColor: !isRated ? '' : theme.palette.like }}
        >
            {model.calculated_rating.toFixed(2)}
        </Button>
    );
};

const VerifiedIcon = ({ model, fontSize = 16 }) => {
    const getVerificationProps = (verified) => {
        if (!verified) {
            return { color: '#000', title: 'Not verified.' };
        }

        switch (verified) {
            case 'official':
                return { color: '#8e24aa', title: 'Official model.' };
            case 'partner':
                return { color: '#429ef5', title: 'Affiliate model.' };
            case 'good':
                return { color: '#248511', title: 'Good choice.' };
            case 'sponsored':
                return { color: '#d4af37', title: 'Sponsored by brand.' };
            default:
                return { color: '#000', title: 'Not verified.' };
        }
    };

    const { color, title } = getVerificationProps(model.verified);

    return (
        <>
            {model.verified && (
                <Tooltip size="sm" variant="plain" placement="top" title={title}>
                    <Verified style={{ fontSize: fontSize, position: 'relative', top: '0.1em', color }} />
                </Tooltip>
            )}
        </>
    );
};

function CountdownTimer({ targetUtc, currentLanguageData }) {

    const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const calculateTimeLeft = () => {
        const now = Date.now();
        const diff = targetUtc - now;

        if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        return { days, hours, minutes, seconds };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(interval);
    }, [targetUtc]);

    return (
        <Stack sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', color: 'white' }} direction="row" spacing={1}>
            <Tooltip size="sm" variant="plain" placement="top" title={capitalizeFirstLetter(currentLanguageData.day)}>
                <Card color="neutral" variant='soft' sx={{
                    p: 2,
                    borderRadius: 250,
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    {String(timeLeft.days).padStart(2, "0")}
                </Card>
            </Tooltip>
            <p>:</p>
            <Tooltip size="sm" variant="plain" placement="top" title={capitalizeFirstLetter(currentLanguageData.hr)}>
                <Card color="neutral" variant='soft' sx={{
                    p: 2,
                    borderRadius: 250,
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    {String(timeLeft.hours).padStart(2, "0")}
                </Card>
            </Tooltip>
            <p>:</p>
            <Tooltip size="sm" variant="plain" placement="top" title={capitalizeFirstLetter(currentLanguageData.min)}>
                <Card color="neutral" variant='soft' sx={{
                    p: 2,
                    borderRadius: 250,
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    {String(timeLeft.minutes).padStart(2, "0")}
                </Card>
            </Tooltip>
            <p>:</p>
            <Tooltip size="sm" variant="plain" placement="top" title={capitalizeFirstLetter(currentLanguageData.sec)}>
                <Card color="neutral" variant='soft' sx={{
                    p: 2,
                    borderRadius: 250,
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    {String(timeLeft.seconds).padStart(2, "0")}
                </Card>
            </Tooltip>
        </Stack>
    );
}

function Explore() {
    const navigate = useNavigate();
    const location = useLocation();

    const { user, loading: loadingAuth } = useAuth();

    const { currentLanguageData } = useLanguage();

    const [rating, setRating] = useState(5)
    const [isRatingModal, setIsRatingModal] = useState(false);
    const [ratingModel, setRatingModel] = useState(null);

    const handleRating = (rate) => {
        setRating(rate)
    }

    const [editData, setEditData] = useState({
        modelId: null,
        modelVer: 'Mini',
        modelName: '',
        sysInst: '',
        outputInst: '',
        modelAvatar: null,
        modelDescription: null,
        modelVoice: null,
        files: '',
        background: '',
        quick_actions: null,
        personal: false,
        usertag: null
    });

    const handleNull = () => {
        setLoadingSave(false);
        setEditData({
            modelId: null,
            modelVer: 'Mini',
            modelName: '',
            sysInst: '',
            outputInst: '',
            modelAvatar: null,
            modelDescription: null,
            modelVoice: null,
            files: '',
            background: '',
            quick_actions: null,
            personal: false, 
            usertag: null
        });
    };

    const handleEdit = (model) => {
        setLoadingSave(false);
        setEditData({
            ...editData,
            modelId: model.id,
            modelName: model.name ? model.name : "",
            sysInst: model.instructions ? model.instructions : "",
            outputInst: model.output ? model.output : "",
            modelVer: model.model,
            modelAvatar: model.avatar,
            modelDescription: model.description ? model.description : "",
            modelVoice: model.voice,
            files: model.files == null ? '' : model.files,
            background: model.background,
            quick_actions: model.quick_actions,
            personal: model.is_moderated == "PERSONAL" ? true : false,
            usertag: model.usertag
        });
    };

    const handleChangeDesc = (e) => {
        const value = e.target.value;
        if (value.length <= 30) {
            setEditData({
                ...editData,
                modelDescription: value,
            });
        }
    };

    const handleChangePersonal = () => {
        let newCheck = !editData.personal;
        setEditData({
            ...editData,
            personal: newCheck,
        });
    };

    const handleChangeVoice = (event, newValue) => {
        let voiceName = newValue;

        if (voiceName === "disabled") {
            voiceName = null;
        }

        setEditData((prevData) => ({
            ...prevData,
            modelVoice: voiceName,
        }));
    };

    const handleQuickActions = (result) => {
        setEditData((prevData) => ({
            ...prevData,
            quick_actions: result,
        }));
    };

    const handleChangeVer = (event, newValue) => {
        setEditData({
            ...editData,
            modelVer: newValue,
        });
    };

    const handleChangeName = (e) => {
        setEditData({
            ...editData,
            modelName: e.target.value,
        });
    };

    const handleChangeTag = (e) => {
        setEditData({
            ...editData,
            usertag: e.target.value,
        });
    };

    const handleChangeSysInst = (e) => {
        setEditData({
            ...editData,
            sysInst: e.target.value,
        });
    };

    const handleChangeOutputInst = (e) => {
        setEditData({
            ...editData,
            outputInst: e.target.value,
        });
    };

    const [modelsData, setModelsData] = useState({});

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [models, setModels] = useState([]);
    const [categoryModels, setCategoryModels] = useState([]);
    const [totalModels, setTotalModels] = useState(0);

    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(18);

    const [openCreate, setOpenCreate] = useState(false);

    const [loadingSave, setLoadingSave] = useState(false);

    useEffect(() => {
        if (!loadingAuth) {
            const fetchVersionsAndFuncs = async () => {
                try {
                    const response = await fetch(getApiUrl('/v3/ai/versions'));
                    const data = await response.json();
                    setModelsData(data);
                } catch (error) {
                    console.error('Error fetching versions:', error);
                }
            };

            fetchVersionsAndFuncs();
        }
    }, [loadingAuth]);

    useEffect(() => {
        if (loadingAuth) return;

        if (location.pathname !== "/explore/search") {
            fetchAllCategories();
        }
        else {
            const query = new URLSearchParams(location.search);
            const keyword = query.get("keyword") || "";
            const page = query.get("page") || "1";

            setPage(page);
            setSearch(keyword);
            fetchModels(keyword, page);
        }
    }, [location.search, loadingAuth]);

    if (loadingAuth) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: ((window.__TAURI_INTERNALS__ && !isMobile) ? 'calc(100vh - 30px)' : '100vh') }}>
                <CircularProgress color='neutral' />
            </div>
        );
    }

    const fetchAllCategories = async () => {
        setLoading(true);

        try {
            const results = await Promise.all(
                categories.map(async ({ key, value }) => {
                    try {
                        const response = await axios.get(getApiUrl('/v3/ai/models'), {
                            params: { category: value, limit: 6 },
                            headers: { 'Content-Type': 'application/json' }
                        });

                        if (key == "Trending") {
                            setTotalModels(response.data.totalModels);
                        }

                        return { [key]: response.data.models || [] };
                    } catch (error) {
                        console.error(`Error fetching models for category ${key}:`, error);
                        return { [key]: [] };
                    }
                })
            );

            const mergedResults = Object.assign({}, ...results);
            setCategoryModels(mergedResults);
        } catch (error) {
            console.error("Error fetching models:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchModels = (search = '', page) => {
        setLoading(true);
        axios.get(getApiUrl('/v3/ai/models'), {
            params: {
                search,
                limit: itemsPerPage,
                page
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.jwt_token}`,
            },
        })
            .then(response => {
                const modelsData = response.data.models || [];
                const totalItems = response.data.totalModels || 0;
                const totalPages = response.data.totalPages || 1;

                setTotalModels(totalItems);
                setModels(modelsData);
                setTotalPages(totalPages);
                setPage(response.data.currentPage || 1);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            const queryParams = new URLSearchParams();
            if (search.trim() !== "") {
                queryParams.set("keyword", search);
            }

            queryParams.set("page", "1");
            navigate(queryParams.toString() ? `/explore/search?${queryParams}` : `/explore`);
        }
    };

    const handlePageChange = (newPage) => {
        const currentParams = new URLSearchParams(location.search);
        if (currentParams.get("page") == newPage) return;

        if (newPage > 0 && newPage <= totalPages) {
            const queryParams = new URLSearchParams();
            queryParams.set("page", newPage || "1");
            setPage(newPage);
            navigate(`/explore/search?${queryParams}`);
        }
    };

    const handleSetModel = (id) => {
        const newUrl = `/chat?id=${generateGUID()}&model=@${id}`;
        navigate(newUrl);
    };

    const handleFileSelectAndUpload = async () => {
        try {
            const [fileHandle] = await window.showOpenFilePicker({
                types: [
                    {
                        description: 'Images',
                        accept: {
                            'image/jpeg': ['.jpg', '.jpeg'],
                            'image/png': ['.png'],
                            'image/gif': ['.gif'],
                        },
                    },
                ],
            });

            if (fileHandle) {
                const file = await fileHandle.getFile();

                const formData = new FormData();
                formData.append('file', file);

                try {
                    const uploadResponse = await fetch(getApiUrl('/v3/cloud/storage/upload'), {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${user.jwt_token}`,
                        },
                        body: formData,
                    });

                    const responseData = await uploadResponse.json();
                    let url = getApiUrl(`/v3/cloud/storage/get/${responseData.data.fileName}`);

                    setEditData({
                        ...editData,
                        modelAvatar: url,
                    });
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            }
        } catch (error) {
            console.error('Error selecting file:', error);
        }
    };

    const handleBgSelectAndUpload = async () => {
        try {
            const [fileHandle] = await window.showOpenFilePicker({
                types: [
                    {
                        description: 'Images',
                        accept: {
                            'image/jpeg': ['.jpg', '.jpeg'],
                            'image/png': ['.png'],
                            'image/gif': ['.gif'],
                        },
                    },
                ],
            });

            if (fileHandle) {
                const file = await fileHandle.getFile();

                const formData = new FormData();
                formData.append('file', file);

                try {
                    const uploadResponse = await fetch(getApiUrl('/v3/cloud/storage/upload'), {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${user.jwt_token}`,
                        },
                        body: formData,
                    });

                    const responseData = await uploadResponse.json();
                    let url = getApiUrl(`/v3/cloud/storage/get/${responseData.data.fileName}`);

                    setEditData({
                        ...editData,
                        background: url,
                    });
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            }
        } catch (error) {
            console.error('Error selecting file:', error);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(getApiUrl(`/v3/ai/model/delete/${id}`), {
                headers: {
                    'Authorization': `Bearer ${user.jwt_token}`
                }
            });

        } catch (error) {
            if (error.response) {
                console.error('Failed to delete model:', error.response.data);
            } else if (error.request) {
                console.error('No response received from server:', error.request);
            } else {
                console.error('Error during API call:', error.message);
            }
        }

        fetchModels(search, page);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoadingSave(true);
        const modelData = {
            version: editData.modelVer,
            name: editData.modelName,
            systemInstructions: editData.sysInst,
            outputInstructions: editData.outputInst,
            avatar: editData.modelAvatar,
            description: editData.modelDescription,
            voice: editData.modelVoice ? editData.modelVoice : null,
            files: editData.files ? editData.files : null,
            background: editData.background,
            quick_actions: editData.quick_actions,
            personal: editData.personal,
            usertag: editData.usertag.replace("@", "")
        };

        if (editData.modelId) {
            modelData.id = editData.modelId;
        }

        try {
            const response = await axios.post(getApiUrl('/v3/ai/model/update'), modelData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.jwt_token}`
                }
            });
        } catch (error) {
            if (error.response) {
                console.error('Failed to update model:', error.response.data);
            } else if (error.request) {
                console.error('No response received from server:', error.request);
            } else {
                console.error('Error during API call:', error.message);
            }
        }
        setLoadingSave(false);
        setOpenCreate(false);
        fetchModels(search, page);
    };

    const handleRateModel = async () => {
        try {
            const model = models.find(m => m.id === ratingModel.id);

            if (model) {
                model.userRating = rating;
                setModels([...models]);
                setIsRatingModal(false);

                if (rating == 0) {
                    return;
                }

                await axios.post(getApiUrl(`/v3/ai/model/rate/${ratingModel.id}/${rating}`), {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user.jwt_token}`,
                    },
                });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const sortedCategories = Object.entries(categoryModels)
        .sort(([keyA, modelsA], [keyB, modelsB]) => {
            if (keyA === "Trending") return -1;
            if (keyB === "Trending") return 1;
            if (modelsA.length === modelsB.length) {
                return keyA.localeCompare(keyB);
            }
            return modelsB.length - modelsA.length;
        });

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: ((window.__TAURI_INTERNALS__ && !isMobile) ? 'calc(100vh - 30px)' : '100vh') }}>
                <CircularProgress color='neutral' />
            </div>
        );
    }

    return (
        <>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center', width: '100%' }}>
                <Stack sx={{ mt: 8, p: 4, width: '100vw' }}>
                    <Card variant='soft' sx={{ borderRadius: 20, overflow: 'hidden', textAlign: 'center', justifyContent: 'center', alignItems: 'center', mb: 2, px: 4, py: 8 }}>
                        <Waves
                            lineColor="rgba(128, 0, 128, 0.3)"
                            backgroundColor={theme.palette.header.main}
                            waveSpeedX={0.02}
                            waveSpeedY={0.01}
                            waveAmpX={40}
                            waveAmpY={20}
                            friction={0.9}
                            tension={0.01}
                            maxCursorMove={120}
                            xGap={12}
                            yGap={36}
                            style={{ opacity: 0.4 }}
                        />
                            <Typography level='h3'><span style={{ color: '#6e5fde', zIndex: 1 }}>Capricorn Explore</span></Typography>
                            <Input
                                placeholder={currentLanguageData.exploreSearch}
                                sx={{ maxWidth: '500px', width: '100%', fontSize: 14, zIndex: 1 }}
                                value={search}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearchKeyDown}
                                type="text"
                            />
                            <Typography sx={{ zIndex: 1 }} level='body-xs'><span dangerouslySetInnerHTML={{ __html: currentLanguageData.exploreDesc }} /></Typography>
                    </Card>
                    {/* {new Date() - new Date(user.created_at) >= 14 * 24 * 60 * 60 * 1000 && (
                        <PixelCard variant="default">
                            <Box sx={{ position: 'absolute', textAlign: 'center', p: 4 }}>
                                <Stack spacing={1} sx={{ alignItems: 'center' }}>
                                    <Stack>
                                        <Typography level='h2'>BTAI25</Typography>
                                        <Typography>The best technology based on Capricorn AI.</Typography>
                                    </Stack>
                                    <LinearProgress thickness={18} determinate sx={{ width: '100%' }} variant='soft' value={((totalModels - 38) / 1000) * 100} >
                                        <Typography sx={{ zIndex: 2 }} level='body-xs'>
                                            MODERATED: {totalModels - 38}/1000
                                        </Typography>
                                    </LinearProgress>
                                    <Typography level='body-xs'>Sponsored by: GitHub, Defiway, Revolut</Typography>
                                </Stack>
                            </Box>
                        </PixelCard>
                    )} */}
                    {location.pathname == "/explore/search" ? (
                        <>
                            <Typography sx={{ mb: 1 }} level='title-lg'>All models</Typography>
                            <Grid
                                sx={{
                                    width: '100%',
                                    maxWidth: 'none',
                                    height: 'auto',
                                }}
                                container
                                spacing={2}
                                columnSpacing={{ xs: 0, sm: 2, md: 2 }}
                            >
                                {models.length > 0 ? models.map(model => (
                                    <Grid item xs={12} sm={4} md={2} key={model.id}>
                                        <Card variant="plain" sx={{ borderRadius: 20, backgroundColor: theme.palette.header.main }}>
                                            {(model.is_moderated === 'FALSE' && model.author.id == user.id) ? (
                                                <Card
                                                    color="primary"
                                                    variant='soft'
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        left: 8,
                                                        width: 14,
                                                        height: 14,
                                                        aspectRatio: '1/1',
                                                        display: 'flex',
                                                        borderRadius: '50%',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        p: 1
                                                    }}
                                                >
                                                    <HourglassBottom sx={{ width: 16, height: 16 }} />
                                                </Card>
                                            ) : model.is_moderated === 'PERSONAL' ? (
                                                <Card
                                                    color="primary"
                                                    variant='soft'
                                                    invertedColors
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        left: 8,
                                                        display: 'flex',
                                                        borderRadius: 20,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        px: 1,
                                                        py: 0.5
                                                    }}
                                                >
                                                    <Typography level='body-xs'>PERSONAL</Typography>
                                                </Card>
                                            ) : (
                                                <Card
                                                    color="primary"
                                                    variant='soft'
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        left: 8,
                                                        display: 'flex',
                                                        borderRadius: 20,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        px: 1,
                                                        py: 0.5
                                                    }}
                                                >
                                                    <TimeAgo timestamp={model.created_at} currentLanguageData={currentLanguageData} />
                                                </Card>
                                            )}
                                            {model.author.usertag == user.usertag ? (
                                                <Stack direction="row" spacing={1} sx={{ position: 'absolute', top: 8, right: 8 }}>
                                                    <Tooltip size="sm" variant='plain' placement="top" color='danger' title={`${currentLanguageData.delete} ${model.name}.`}>
                                                        <IconButton sx={{ borderRadius: 250 }} onClick={() => handleDelete(model.id)} color='danger' variant='plain' size='sm'>
                                                            <MdDelete style={{ height: 18, width: 18 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip size="sm" sx={{ borderRadius: 250 }} variant='plain' placement="top" title={`${currentLanguageData.edit} ${model.name}.`}>
                                                        <IconButton onClick={() => { handleEdit(model); setOpenCreate(true); }} variant='plain' size='sm'>
                                                            <RiPencilFill style={{ height: 18, width: 18 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            ) : (
                                                <Stack direction="row" spacing={1} sx={{ position: 'absolute', top: 8, right: 8 }}>
                                                    <Tooltip arrow size="sm" variant='soft' placement="top" color='warning' title={`${currentLanguageData.donate}`}>
                                                        <IconButton disabled sx={{ borderRadius: 250 }} onClick={() => handleDelete(model.id)} color='warning' variant='soft' size='sm'>
                                                            <Cake style={{ height: 18, width: 18 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            )}

                                            <Stack sx={{ display: 'flex', flex: 1, flexDirection: 'column', textAlign: 'center', width: '100%' }} spacing={1.4}>
                                                <Box sx={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center' }}>
                                                    <Avatar src={model.avatar} size="lg">{model.name.charAt(0)}</Avatar>
                                                </Box>
                                                <Stack spacing={0.4}>
                                                    <Typography level="title-lg" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                                                        {model.name} <VerifiedIcon model={model} />
                                                    </Typography>

                                                    <Typography level="body-xs">{currentLanguageData.based} Capricorn {model.model}</Typography>
                                                    <Typography sx={{ opacity: 0.8 }} noWrap level="body-xs">{model.description ? model.description : currentLanguageData.intmemNan}</Typography>
                                                </Stack>
                                                <Card variant="soft" sx={{ borderRadius: 20 }}>
                                                    <Stack spacing={1} direction="row" justifyContent="center" alignItems="center">
                                                        <Avatar size="sm" variant="outlined" src={model.author.avatar} />
                                                        <Typography level="body-sm">{model.author.username}</Typography>
                                                    </Stack>
                                                </Card>
                                                {!model.avalibleinchat ? (
                                                    <Tooltip size="sm" placement="top" title={currentLanguageData.notAvalibleModel}>
                                                        <span>
                                                            <Button
                                                                onClick={() => handleSetModel(model.usertag)}
                                                                variant="soft"
                                                                color="neutral"
                                                                fullWidth
                                                                sx={{ borderRadius: 250 }}
                                                                disabled={!model.avalibleInChat}
                                                                startDecorator={<RiMessage2Fill style={{ opacity: 0.7 }} />}
                                                            >
                                                                {currentLanguageData.startChat}
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Button
                                                            sx={{ flexGrow: 1, borderRadius: 250 }}
                                                            onClick={() => handleSetModel(model.usertag)}
                                                            variant="soft"
                                                            color="neutral"
                                                            fullWidth
                                                            startDecorator={<RiMessage2Fill style={{ opacity: 0.7 }} />}
                                                        >
                                                            {currentLanguageData.startChat}
                                                        </Button>
                                                        <LikeButton theme={theme} onClickEvent={() => { setIsRatingModal(true); setRatingModel(model); setRating(model.userRating ? model.userRating : 5); }} model={model} user={user} />
                                                    </div>
                                                )}
                                            </Stack>
                                        </Card>
                                    </Grid>
                                )) : (
                                    <Box sx={{ width: '100%', textAlign: 'center', marginY: 4 }} >
                                        <Typography level="body-sm" sx={{ ml: 2 }}>No models available.</Typography>
                                    </Box>
                                )}
                            </Grid>
                            <Stack spacing={2} direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
                                <IconButton
                                    onClick={() => handlePageChange(page - 1)}
                                    disabled={page === 1}
                                    color='neutral'
                                    variant='soft'
                                    sx={{ borderRadius: 250 }}
                                >
                                    <ArrowLeft />
                                </IconButton>
                                <Typography level="body-sm">{page} {currentLanguageData.of} {totalPages}</Typography>
                                <IconButton
                                    onClick={() => handlePageChange(page + 1)}
                                    disabled={page === totalPages}
                                    color='neutral'
                                    variant='soft'
                                    sx={{ borderRadius: 250 }}
                                >
                                    <ArrowRight />
                                </IconButton>
                            </Stack>
                        </>
                    ) : (
                        <Stack spacing={0.2}>
                            {sortedCategories.map(([category, models]) => (
                                <React.Fragment key={category}>
                                    <Typography sx={{ pl: 1 }} level="title-lg">{category.replace("_", " & ")}</Typography>
                                    <ModelsByCategory
                                        modelsByCategory={models}
                                        theme={theme}
                                        handleSetModel={handleSetModel}
                                        currentLanguageData={currentLanguageData}
                                    />
                                </React.Fragment>
                            ))}
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => navigate(`/explore/search?page=1`)} startDecorator={<ExploreIcon />} variant="soft" sx={{ borderRadius: 250 }}>{currentLanguageData.seeAll}</Button>
                            </Box>
                        </Stack>
                    )}
                </Stack>

                <IconButton onClick={() => { handleNull(); setOpenCreate(true); }} variant='soft' size='lg' sx={{ position: 'fixed', bottom: 20, right: 20, borderRadius: 250, backgroundColor: theme.palette.add.def, '&:hover': { backgroundColor: theme.palette.add.hover, } }}>
                    <Add />
                </IconButton>
            </div>

            <Transition in={openCreate} timeout={400}>
                {(state) => (
                    <Drawer
                        open={openCreate}
                        size={isMobile ? 'lg' : 'md'}
                        anchor="right"
                        onClose={() => setOpenCreate(false)}
                        sx={{
                            zIndex: 9999,
                            '--Drawer-transitionDuration': openCreate ? '0.4s' : '0.2s',
                            '--Drawer-transitionFunction': openCreate
                                ? 'cubic-bezier(0.79,0.14,0.15,0.86)'
                                : 'cubic-bezier(0.77,0,0.18,1)',
                        }}
                    >
                        <ModalClose sx={{ mt: ((window.__TAURI_INTERNALS__ && !isMobile) ? '30px' : 0), borderRadius: 250 }} />
                        <DialogTitle sx={{ pt: ((window.__TAURI_INTERNALS__ && !isMobile) ? '30px' : 0) }}>{currentLanguageData.createModelTitle}</DialogTitle>
                        <DialogContent sx={{ mt: 1, overflowX: 'hidden', scrollbarWidth: 'none', mb: 6.2 }}>
                            <form onSubmit={handleSubmit}>
                                <Stack sx={{ mb: 2 }}>
                                    <FormControl sx={{ justifyContent: 'center', display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <Avatar
                                            onClick={handleFileSelectAndUpload}
                                            src={editData.modelAvatar ? editData.modelAvatar : null}
                                            sx={{ cursor: 'pointer' }}
                                            size="lg"
                                        >
                                            {editData.modelId ? editData.modelName.charAt(0) : "?"}
                                        </Avatar>
                                    </FormControl>
                                    <AccordionGroup sx={{ borderRadius: 20, mt: 1 }}>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.basicSettings}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Select value={editData.modelVer} onChange={handleChangeVer} name="version" required sx={{ fontSize: 14, borderRadius: 20, borderColor: '#8e24aa' }}>
                                                        {Object.entries(modelsData.versions).map(([label, value]) => (
                                                            value != "4.4" && <Option key={value} value={value}>{label}</Option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Input
                                                        name="name"
                                                        required
                                                        value={editData.modelName}
                                                        onChange={handleChangeName}
                                                        placeholder={currentLanguageData.createModelName}
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            '&::before, &::after': { background: 'transparent', filter: null },
                                                        }}
                                                        type="text"
                                                    />
                                                </FormControl>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Input
                                                        name="tag"
                                                        required
                                                        value={editData.usertag}
                                                        onChange={handleChangeTag}
                                                        placeholder="@username"
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            '&::before, &::after': { background: 'transparent', filter: null },
                                                        }}
                                                        type="text"
                                                    />
                                                </FormControl>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Input
                                                        name="desc"
                                                        value={editData.modelDescription}
                                                        onChange={handleChangeDesc}
                                                        placeholder={currentLanguageData.createModelDesc}
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            '&::before, &::after': { background: 'transparent', filter: null },
                                                        }}
                                                        type="text"
                                                    />
                                                </FormControl>
                                                <FormControl sx={{ mt: 1.5 }}>
                                                    <Checkbox
                                                        color="neutral"
                                                        variant="soft"
                                                        size='sm'
                                                        checked={editData.personal}
                                                        onChange={handleChangePersonal}
                                                        sx={{
                                                            '.MuiCheckbox-checkbox': {
                                                                borderRadius: 250,
                                                            },
                                                            '.MuiCheckbox-label': {
                                                                opacity: 0.8,
                                                            }
                                                        }}
                                                        label={currentLanguageData.personal} />
                                                </FormControl>
                                                <FormControl sx={{ mt: 1.5 }}>
                                                    <Checkbox
                                                        disabled
                                                        color="warning"
                                                        variant="soft"
                                                        size='sm'
                                                        sx={{
                                                            '.MuiCheckbox-checkbox': {
                                                                borderRadius: 250,
                                                            },
                                                            '.MuiCheckbox-label': {
                                                                opacity: 0.8,
                                                            }
                                                        }}
                                                        label={currentLanguageData.onlySub} />
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.functions}</AccordionSummary>
                                            <AccordionDetails>
                                                {Object.entries(modelsData.functions).map(([index, func]) => (
                                                    <FormControl size="sm" sx={{ mt: 1 }}>
                                                        <Checkbox
                                                            color='neutral'
                                                            variant='plain'
                                                            sx={{ '& .Mui-checked': { borderRadius: 250 } }}
                                                            disabled={!func.versions.includes(editData.modelVer)}
                                                            checked={func.versions.includes(editData.modelVer)}
                                                            label={
                                                                <React.Fragment>
                                                                    {func.name}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                        <FormHelperText>
                                                            <Typography level="body-sm" sx={{ mt: 0.4 }}>
                                                                {func.description}
                                                            </Typography>
                                                        </FormHelperText>
                                                    </FormControl>
                                                ))}
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.instructions}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Textarea
                                                        name="system_instructions"
                                                        required
                                                        value={editData.sysInst}
                                                        onChange={handleChangeSysInst}
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            '&::before, &::after': { background: 'transparent', filter: null },
                                                            'textarea': { marginRight: 0, marginLeft: 0, marginTop: 0.1, marginBottom: 0, scrollbarWidth: 'none' }
                                                        }}
                                                        placeholder={currentLanguageData.createModelSysInst}
                                                    />
                                                </FormControl>

                                                <FormControl sx={{ mt: 1 }}>
                                                    <Textarea
                                                        name="output_instructions"
                                                        value={editData.outputInst}
                                                        onChange={handleChangeOutputInst}
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            '&::before, &::after': { background: 'transparent', filter: null },
                                                            'textarea': { marginRight: 0, marginLeft: 0, marginTop: 0.1, marginBottom: 0, scrollbarWidth: 'none' }
                                                        }}
                                                        placeholder={currentLanguageData.createModelOutInst}
                                                    />
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.usability}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Select
                                                        value={editData.modelVoice ? editData.modelVoice : "disabled"}
                                                        onChange={handleChangeVoice}
                                                        name="voice"
                                                        required
                                                        sx={{ fontSize: 14, borderRadius: 20, borderColor: '#8e24aa' }}>
                                                        <Option key="disabled" value="disabled">{currentLanguageData.disablevoice}</Option>
                                                        <Option key="alloy" value="alloy">Alloy</Option>
                                                        <Option key="amuch" value="amuch">Amuch</Option>
                                                        <Option key="ash" value="ash">Ash</Option>
                                                        <Option key="aster" value="aster">Aster</Option>
                                                        <Option key="ballad" value="ballad">Ballad</Option>
                                                        <Option key="brook" value="brook">Brook</Option>
                                                        <Option key="clover" value="clover">Clover</Option>
                                                        <Option key="coral" value="coral">Coral</Option>
                                                        <Option key="dan" value="dan">Dan</Option>
                                                        <Option key="echo" value="echo">Echo</Option>
                                                        <Option key="elan" value="elan">Elan</Option>
                                                        <Option key="fable" value="fable">Fable</Option>
                                                        <Option key="marilyn" value="marilyn">Marilyn</Option>
                                                        <Option key="meadow" value="meadow">Meadow</Option>
                                                        <Option key="nova" value="nova">Nova</Option>
                                                        <Option key="onyx" value="onyx">Onyx</Option>
                                                        <Option key="sage" value="sage">Sage</Option>
                                                        <Option key="shimmer" value="shimmer">Shimmer</Option>
                                                        <Option key="verse" value="verse">Verse</Option>
                                                    </Select>
                                                </FormControl>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <Button
                                                        name="background"
                                                        variant='outlined'
                                                        onClick={() => handleBgSelectAndUpload()}
                                                        sx={{
                                                            fontSize: 14,
                                                            borderRadius: 20,
                                                            borderColor: '#8e24aa',
                                                            color: theme.palette.text.primary,
                                                            fontWeight: '400',
                                                            textAlign: 'left',
                                                            '&:hover': { borderColor: '#6a1b9a', backgroundColor: '#FFFFFF10' }
                                                        }}
                                                    >{editData.background ? editData.background.replace("https://api.screwltd.com/v3/cloud/storage/get/", "") : currentLanguageData.uploadBackground}</Button>
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.chatSettings}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl sx={{ mt: 1 }}>
                                                    <InputPairs currentLanguageData={currentLanguageData} onChange={handleQuickActions} value={editData.quick_actions} />
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion>
                                            <AccordionSummary>{currentLanguageData.files}</AccordionSummary>
                                            <AccordionDetails>
                                                <DragAndDrop model={editData} user={user} msg={currentLanguageData.drag} />
                                            </AccordionDetails>
                                        </Accordion>
                                    </AccordionGroup>
                                </Stack>

                                <Box sx={{ position: isMobile ? 'relative' : 'absolute', px: 1.5, bottom: isMobile ? 20 : 15, left: 0, right: 0 }}>
                                    <Button
                                        loading={loadingSave}
                                        type="submit"
                                        color="neutral"
                                        sx={{
                                            mt: 1,
                                            width: '100%',
                                            borderRadius: 20,
                                            backgroundColor: '#6a1b9a99',
                                            '&:hover': { backgroundColor: '#6a1b9a' },
                                        }}
                                    >
                                        <Check />
                                    </Button>
                                </Box>
                            </form>
                        </DialogContent>
                    </Drawer>
                )}
            </Transition >

            <Transition in={isRatingModal} timeout={400}>
                {(state) => (
                    <Modal
                        keepMounted
                        open={!['exited', 'exiting'].includes(state)}
                        onClose={() => setIsRatingModal(false)}
                        slotProps={{
                            backdrop: {
                                sx: {
                                    opacity: 0,
                                    backdropFilter: 'none',
                                    transition: `opacity 400ms, backdrop-filter 400ms`,
                                    ...{
                                        entering: { opacity: 1, backdropFilter: 'blur(8px)' },
                                        entered: { opacity: 1, backdropFilter: 'blur(8px)' },
                                    }[state],
                                },
                            },
                        }}
                        sx={{
                            zIndex: 10000,
                            visibility: state === 'exited' ? 'hidden' : 'visible',
                        }}
                    >
                        <ModalDialog
                            layout='center'
                            variant="plain"
                            sx={{
                                opacity: 0,
                                borderRadius: 20,
                                transition: `opacity 300ms`,
                                ...{
                                    entering: { opacity: 1 },
                                    entered: { opacity: 1 },
                                }[state],
                            }}
                        >
                            <ModalClose sx={{ borderRadius: 250 }} />
                            <DialogTitle>{ratingModel?.name}</DialogTitle>
                            <DialogContent sx={{ pt: 1, scrollbarWidth: 'none', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                <Rating onClick={handleRating} initialValue={rating} />
                                <Button onClick={() => handleRateModel()} sx={{ borderRadius: 20, mt: 1, width: '100%' }} color='warning' variant='soft'>{currentLanguageData.submit}</Button>
                            </DialogContent>
                        </ModalDialog>
                    </Modal>
                )}
            </Transition >
        </>
    );
}

const ModelsByCategory = ({ modelsByCategory, handleSetModel, currentLanguageData, theme }) => {
    return (
        <Grid container spacing={2} columnSpacing={{ xs: 0, sm: 2, md: 2 }} sx={{ width: '100%', maxWidth: 'none', height: 'auto', pb: 1 }}>
            {modelsByCategory.map(model => (
                <Grid item xs={12} sm={4} md={2} key={model.id}>
                    <Button onClick={() => handleSetModel(model.usertag)} variant="plain" sx={{ borderRadius: 20, backgroundColor: theme.palette.header.main, position: 'relative', p: "1rem", textAlign: 'left', width: '100%', '&:hover': { backgroundColor: theme.palette.neutral.softHoverBg, }, '&:active': { backgroundColor: theme.palette.neutral.softActiveBg, } }}>
                        <Box sx={{ display: "flex", alignItems: "center", width: '100%' }}>
                            <Avatar src={model.avatar} size="lg">{model.name.charAt(0)}</Avatar>
                            <Box sx={{ pl: 2, maxWidth: '100%', minWidth: 0 }}>
                                <Stack>
                                    <Typography noWrap level="title-md" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                                        {model.name} <VerifiedIcon fontSize={13} model={model} />
                                    </Typography>
                                    <Typography sx={{ opacity: 0.8, width: '100%' }} noWrap level="body-xs">{model.description || currentLanguageData.intmemNan}</Typography>
                                    <Typography noWrap level="body-xs">
                                        {currentLanguageData.from} {model.author.username}
                                    </Typography>
                                </Stack>
                            </Box>
                        </Box>
                    </Button>
                </Grid>
            ))}
        </Grid>
    );
};

export default Explore;
